import { shallowMount } from "@vue/test-utils";
import ValidatedInput from "@/components/core/ValidatedInput";

describe("ValidatedInput component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ValidatedInput);
  });

  it("Renders del component ValidatedInput", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
